<template lang="html">
	<div class="center">
		<a-icon type="check-circle" :style="{fontSize: '60px', marginBottom: '1rem', color: '#87d068'}"  />
		<p>Incident pris en charge.</p>
	</div>
</template>
<script>
export default {
	name: "Technician",
}
</script>
<style lang="scss" scoped>

</style>